import React, {useMemo, useState} from 'react';
import {TaskListWrapper} from '../../../../my-work-tab/my-tasks-page/MyWork.styled';
import TaskRow from './Task_row';
import TaskListHeader from './Task_row_header';
import Util from '../../../util/util';
import {hasFeatureFlag} from '../../../util/FeatureUtil';
import {shouldShowNovaColumn} from '../../nova-invocation/eligibility';

export const TaskList = ({
	intl,
	enabledColumns,
	tasks,
	history,
	viewer,
	enableSort,
	stickyTopPosition,
	isInContainer,
	localSortKey,
	cy,
	showNovaColumn: showNovaColumnOverride,
}) => {
	const [sortBy, setSortBy] = useState(
		localSortKey && Util.localStorageGetItem(localSortKey)
			? JSON.parse(Util.localStorageGetItem(localSortKey))
			: {column: null, ascending: false}
	);
	Util.sortTasks(tasks, sortBy);

	const setSorting = sortBy => {
		if (enableSort) {
			setSortBy(sortBy);
			if (localSortKey) {
				Util.localStorageSetItem(localSortKey, JSON.stringify(sortBy));
			}
		}
	};

	// Computed once here, not independently by the header and each row, so the two can never
	// disagree on whether the Nova column's width is reserved (a header/row width mismatch
	// misaligns every column after it). A caller that renders several sibling TaskLists sharing one
	// underlying task set (MyWorkMyTasks.js's this-week/no-dates/done sections) must instead compute
	// this once itself, across all of them combined, and pass it down as showNovaColumn - otherwise
	// a locked task in only one section shows the column there and not in its siblings, misaligning
	// every one of them against each other. A caller with its own independent task set (e.g.
	// MyWorkOverdueTasksSection.js) omits the prop and gets this per-list computation instead.
	const computedShowNovaColumn = useMemo(
		() =>
			hasFeatureFlag('nova_agent_invocation') &&
			shouldShowNovaColumn({
				isClientActionsRestricted: Util.isClientTaskActionsRestricted(viewer),
				anyVisibleTaskLocked: tasks.some(task => !!task.node?.readOnly?.isReadOnly),
			}),
		[tasks, viewer]
	);
	const showNovaColumn = showNovaColumnOverride !== undefined ? showNovaColumnOverride : computedShowNovaColumn;

	return (
		<TaskListWrapper>
			<TaskListHeader
				intl={intl}
				enabledColumns={enabledColumns}
				sortBy={sortBy}
				onSortByChange={enableSort ? sortBy => setSorting(sortBy) : null}
				stickyTopPosition={stickyTopPosition}
				isInContainer={isInContainer}
				showNovaColumn={showNovaColumn}
			/>
			{tasks.map(task => (
				<TaskRow
					cy={cy}
					key={task.node.id}
					intl={intl}
					task={task.node}
					enabledColumns={enabledColumns}
					showTaskModal={taskId => Util.showTaskModal(taskId, history)}
					viewer={viewer} //TODO to removed, only used for Generic task context menu
					showNovaColumn={showNovaColumn}
				/>
			))}
		</TaskListWrapper>
	);
};
